import React, { useContext } from "react";
import {Box} from "grommet";
import {downloadCSV} from "../lib/exportcsv";
import { NotificationsContext } from "./NotificationsProvider";
import {
    faArrowRightFromBracket as IconExport
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";

const ExportButton = ({ data, exportConfigs, filename, isFullData, getFullData, onExportCSVClicked, dataName= '' }) => {
    const notificationCtx = useContext(NotificationsContext);
    return (
        <Box width={{ max: 'small' }} align="center" justify="center">
            <Button
                event={{section: `${dataName}_data_table`, element: 'export_csv'}}
                onClick={
                    onExportCSVClicked ?
                        onExportCSVClicked : (
                            async () => {
                                const dataToDownload = !isFullData ? (await getFullData()) : data;
                                dataToDownload ?
                                    downloadCSV(dataToDownload, exportConfigs, filename) :
                                    notificationCtx.showNotification({message: 'Something went wrong. Please try exporting CSV later.', type: 'error'});
                            }
                        )
                }
                icon={<FontAwesomeIcon SelectedIcon={IconExport} size="small" />}
                aria-label="Export CSV"
                tip="Export CSV"
                hoverIndicator
            />
        </Box>
    );
};

export default ExportButton;